"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumber;
/**
 * Checks whether or not a value is a number.
 *
 * @param {any} value evaluate if number
 * @returns {boolean} isNumber
 */
function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}